<template>

  <div class="container-fluid bg-gray">      
    <div class="row articulo">    
      <div class="col-12">
        <div>          
          <p>
            {{$t('buscador_articulo')}}           
          </p>
          <BuscadorField :dataset="dataset" />
        </div>
      </div>
    </div>
  </div>
    
</template>
<script>

  import BuscadorField from './BuscadorField.vue'

  export default {
    name: 'Buscador',
    props: {
      dataset: Array
    },
    components: {
      BuscadorField
    }
  }
    


</script>